
<!-- /**
 * @author Ketan Shetye
 * @created 2025-11-03
 */ -->
<div class="main-container">
<div class="applicant-header">
    <wm-common-text [data]="{text:data.header}" ></wm-common-text>
</div>
<div class="sub-header">
    <wm-common-text [data]="{text:data.subHeader}" ></wm-common-text>
</div>
</div>
